export const ANIMATION_DEFAULT_TIMING: Readonly<number> = 250; // Value is interpreted as ms
